import React from 'react';
import useApi from './useApi';
import { LS_KEYS } from '../hooks';

const BASE_URL = '/item-menu';

export const useMenuItem = () => {
  // ******************************Backoffice********************************
  const { get, post, put, remove: removeMenuItem } = useApi(LS_KEYS.BACKOFFICE);

  /**
   * List all menu item
   */
  const list = React.useCallback(async () => {
    const items = get(BASE_URL);
    return items;
  }, [get]);

  /**
   * Loa a menu item
   */
  const load = React.useCallback(
    async id => {
      const loadedData = get(`${BASE_URL}/${id}`);
      return loadedData;
    },
    [get],
  );

  /**
   * Create a menu item
   */
  const create = React.useCallback(
    async data => {
      const createdData = post(BASE_URL, data);
      return createdData;
    },
    [post],
  );

  /**
   * Update a menu item
   */
  const update = React.useCallback(
    async (id, data) => {
      const updatedData = put(`${BASE_URL}/${id}`, data);
      return updatedData;
    },
    [put],
  );

  /**
   * Update a menu item image
   */
  const updateImage = React.useCallback(
    async (id, data) => {
      const updatedData = put(`${BASE_URL}/${id}/image`, data);
      return updatedData;
    },
    [put],
  );

  /**
   * Remove a menu item
   */
  const remove = React.useCallback(
    async id => {
      const removedData = removeMenuItem(`${BASE_URL}/${id}`);
      return removedData;
    },
    [removeMenuItem],
  );

  // ******************************Site********************************
  const { get: getSite } = useApi(LS_KEYS.SITE);

  /**
   * List all menu item
   */
  const listSite = React.useCallback(async () => {
    const items = getSite(`${BASE_URL}/site/list?active=true`);
    return items;
  }, [getSite]);

  return { list, load, create, update, updateImage, remove, listSite };
};

export default useMenuItem;
